// Фабрика, которая хранит активные и архивные движущиеся объекты
// Создает новый объект либо берет из архива и переинициализирует

// import MovableObjectModel from '../models/movableObjectModel';
import gameObjectTypes from '../constants/gameObjectTypes';
import gameSettings from '../constants/gameSettings';
import LootMovableObjectModel from '../models/lootMovableObjectModel';
import MovableObjectModel from '../models/movableObjectModel';
import GameObjectView from '../views/gameObjectView';

export default class GameMovableObjectsFactory {
    activeObjects = {};
    archiveObjects = {};
    lastAddedObject = null;
    maxZIndex = 1000;
    lastZIndex = this.maxZIndex;

    // usedGameObjectTypes = array, Model - модель, которую создавать ?
    constructor(usedGameObjectTypes) {
        usedGameObjectTypes.forEach((type) => {
            this.activeObjects[type] = [];
            this.archiveObjects[type] = [];
        });
    }

    addObject(type, args) {
        let gameObject = {};

        if (this.archiveObjects[type]?.[0]) {
            gameObject = { ...this.archiveObjects[type][0] };
            this.archiveObjects[type].shift();
        } else {
            if (type === gameObjectTypes.LOOT_OBJECT) {
                gameObject.model = new LootMovableObjectModel(type, args);
                // console.log(`addObject${args.option}`);
            } else {
                gameObject.model = new MovableObjectModel(type);
            }

            gameObject.view = new GameObjectView(type, {
                startPoint: {
                    ...gameObject.model.startPoint
                }
            });
        }

        if (gameObject.model
            && gameObject.view
            && Array.isArray(this.activeObjects[type])
        ) {
            gameObject.model.init(args);
            gameObject.view.update(gameObject.model.x, gameObject.model.y, gameObject.model.scale);

            setTimeout(() => {
                gameObject.view.init(args);
                gameObject.model.show?.();
                const lootOption = gameObject.model.option;

                if (lootOption) {
                    gameObject.view.gameObjectEl.addClasses([lootOption]);
                    gameObject.view.setZIndexNum(this.maxZIndex + 1);
                }

                // set z index for loots
                // if (type === gameObjectTypes.LOOT_OBJECT) {
                //     if (this.activeObjects[type].length > 1) {
                //         this.activeObjects[type].forEach((lootObject) => {
                //             lootObject.view.setZIndex6();
                //         });

                //         gameObject.view.setZIndex5();
                //     } else {
                //         gameObject.view.setZIndex6();
                //     }
                // }

                const typesToIgnoreDynamicZIndex = [
                    gameObjectTypes.LOOT_OBJECT,
                    gameObjectTypes.DIVIDE_LINE,
                    gameObjectTypes.CURBSTONE_SEPARATOR_LEFT,
                    gameObjectTypes.CURBSTONE_SEPARATOR_RIGHT
                ];

                if (!typesToIgnoreDynamicZIndex.includes(type)) {
                    gameObject.view.setZIndexNum(this.lastZIndex);
                    this.lastZIndex -= 1;
                }
            }, (1000 / gameSettings.fps) * 1000);

            this.activeObjects[type].push(gameObject);
            this.lastAddedObject = gameObject;
        } else {
            this.lastAddedObject = null;
        }
    }

    shiftObject(type) {
        this.activeObjects[type][0].view.hide();
        this.archiveObjects[type].push(this.activeObjects[type][0]);
        this.activeObjects[type].shift();
    }

    clearObjects() {
        Object.keys(this.activeObjects).forEach((objectType) => {
            this.activeObjects[objectType].forEach((object) => {
                object.view.remove();
            });

            this.activeObjects[objectType] = [];
        });

        Object.keys(this.archiveObjects).forEach((objectType) => {
            this.archiveObjects[objectType].forEach((object) => {
                object.view.remove();
            });

            this.archiveObjects[objectType] = [];
        });

        this.lastAddedObject = null;
        this.lastZIndex = this.maxZIndex;
    }
}
